import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private title: Title, private meta: Meta) { }

  // Loading
  isLoading = new BehaviorSubject<any>(false);

  // String Cut
  trimString(string) {
    if (string.length > 60) {
      string = string.substring(0, 57) + '...';
    }
    return string;
  }

  // String Cut
  trimString2(string: string, trim: number) {
    if (string.length > (trim + 5)) {
      string = string.substring(0, trim) + '...';
    }
    return string;
  }

  // Meta
  updateMeta(
    title: string,
    keyw:string,
    desc: string) 
  {
    this.title.setTitle(title);
    this.meta.updateTag({ name: 'title', content: title });
    this.meta.updateTag({ name: 'keywords', content: keyw });
    this.meta.updateTag({ name: 'description', content: desc });
  }

}
